// The two sides of every theater: Crimson and Cobalt, never red and blue.
// `color` is the team hue that friend-or-foe reads off at a glance — a hull's
// or an emplacement's `*_Team` band, and every pilot's nameplate tile (no
// aircraft wears a side: aircraft_models.js) — and no paint scheme ever
// touches it. `body`/`accent` are its darker and paler companions for trim —
// the nameplate's rim and title row, a carrier's deck thresholds, a base's
// banding, a parachuted pilot's flight suit.
//
// Its own module so the model loader (models.js) can paint a team without
// importing the whole plane builder; planes.js re-exports it for everyone else.
export const TEAM_CRIMSON = 0;
export const TEAM_COBALT = 1;

export const TEAM_INFO = [
  { name: "CRIMSON", color: 0xe84a4a, body: 0xb23a3a, accent: 0xf2e3c8, cssColor: "#e84a4a" },
  { name: "COBALT", color: 0x4a7de8, body: 0x3a5cb2, accent: 0xdce8f2, cssColor: "#4a7de8" },
];
